import { FlexContainer } from '@/ui/flexbox/flexbox';

import { AskXButton } from '../../../ask-x/ask-x-button';
import { TopbarWrapper } from '../../topbar';
import { CreateDropdownWithButton } from '@/components/create-dropdown/create-dropdown-with-button';
import { NotificationsButton } from '../../../notifications/notifications-button';

export const HomeHeader = () => {
  return (
    <TopbarWrapper name="home-header" bgColor="transparent">
      <FlexContainer gap="28px" grow={1} justify="flex-end">
        <NotificationsButton />
        <AskXButton />
        <CreateDropdownWithButton />
      </FlexContainer>
    </TopbarWrapper>
  );
};
